import { render } from "./ListaOrdiniSenzaCalendario.vue?vue&type=template&id=62a3a5b4"
import script from "./ListaOrdiniSenzaCalendario.vue?vue&type=script&lang=js"
export * from "./ListaOrdiniSenzaCalendario.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__